define('StockStatusTags.Utils', [], function () {
  'use strict';

  function isChecked(value) {
    return value === true || value === 'T';
  }

  var SEASON_LIST_VALUES = {
    1: { label: 'Spring 2026', state: 'availability-spring' },
    2: { label: 'Summer 2026', state: 'availability-summer' },
    3: { label: 'Fall 2026', state: 'availability-fall' },
    4: { label: 'Winter 2026', state: 'availability-winter' },
    5: { label: 'Spring 2027', state: 'availability-spring' },
    6: { label: 'Winter 2027', state: 'availability-winter' }
  };

  function parseSeasonTag(value) {
    var entry;
    var text;
    var lower;

    if (value === null || typeof value === 'undefined' || value === '') {
      return null;
    }

    entry = SEASON_LIST_VALUES[value];
    if (entry) {
      return { label: 'Availability: ' + entry.label, state: entry.state };
    }

    text = value.toString().trim();
    lower = text.toLowerCase();

    if (lower.indexOf('spring') === 0) {
      return { label: 'Availability: ' + text, state: 'availability-spring' };
    }
    if (lower.indexOf('summer') === 0) {
      return { label: 'Availability: ' + text, state: 'availability-summer' };
    }
    if (lower.indexOf('fall') === 0) {
      return { label: 'Availability: ' + text, state: 'availability-fall' };
    }
    if (lower.indexOf('winter') === 0) {
      return { label: 'Availability: ' + text, state: 'availability-winter' };
    }

    return null;
  }

  function buildScaleTag(value) {
    var text;

    if (value === null || typeof value === 'undefined' || value === '') {
      return null;
    }

    text = value.toString().trim().replace(/\s*scale\s*$/i, '').trim();
    if (!text) {
      return null;
    }

    return { label: 'Scale: ' + text, state: 'scale' };
  }

  function buildBrandTag(value) {
    var text;

    if (value === null || typeof value === 'undefined' || value === '') {
      return null;
    }

    text = value.toString().trim();
    if (!text) {
      return null;
    }

    return { label: 'Brand: ' + text, state: 'brand' };
  }

  function buildRoadNameTag(value) {
    var text;

    if (value === null || typeof value === 'undefined' || value === '') {
      return null;
    }

    text = value.toString().trim();
    if (!text) {
      return null;
    }

    return { label: 'Road Name: ' + text, state: 'road-name' };
  }

  function buildItemTags(item) {
    var tags = [];
    var seasonTag;
    var scaleTag;
    var roadNameTag;
    var brandTag;

    if (isChecked(item.custitem_walthers_item_instock)) {
      tags.push({ label: 'In Stock', state: 'in-stock' });
    }

    if (isChecked(item.custitem_walthers_item_preorder)) {
      tags.push({ label: 'Pre-Order', state: 'preorder' });
    }

    if (isChecked(item.custitem_walthers_item_new)) {
      tags.push({ label: 'New Arrivals', state: 'new-arrival' });
    }

    if (isChecked(item.custitem_walthers_item_hot)) {
      tags.push({ label: 'Hot List', state: 'hot-list' });
    }

    if (isChecked(item.custitem_walthers_limit_qty_avail)) {
      tags.push({ label: 'Limited Qty Available', state: 'limited' });
    }

    if (isChecked(item.custitem_walthers_temporarily_sold_out)) {
      tags.push({ label: 'Temporarily sold out', state: 'sold-out' });
    }

    if (isChecked(item.custitem_walthers_item_disc)) {
      tags.push({ label: 'Discontinued', state: 'discontinued' });
    }

    if (isChecked(item.custitem_walthers_special_order)) {
      tags.push({ label: 'Special Order', state: 'special-order' });
    }

    if (isChecked(item.custitem_walthers_availability_tba)) {
      tags.push({ label: 'Availability: TBA', state: 'availability-tba' });
    }

    seasonTag = parseSeasonTag(item.custitem_walthers_item_season);
    if (seasonTag) {
      tags.push(seasonTag);
    }

    scaleTag = buildScaleTag(item.custitem_walthers_item_scale);
    if (scaleTag) {
      tags.push(scaleTag);
    }

    roadNameTag = buildRoadNameTag(item.custitem_walthers_item_road_name);
    if (roadNameTag) {
      tags.push(roadNameTag);
    }

    brandTag = buildBrandTag(item.custitem_walthers_item_brand);
    if (brandTag) {
      tags.push(brandTag);
    }

    return tags;
  }

  return {
    buildItemTags: buildItemTags
  };
});
